import { each, keys } from 'lodash-es'

import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

// Application stores
import application from './application'
import home from './home'
import metadata from './metadata'
import settings from './settings'
import capabilities from './capabilities'
import notifications from './notifications'
import filters from './filters'

// Common stores
import authenticatedUser from './authenticatedUser'
import roles from './roles'
import customers from './customers'
import fleets from './fleets'
import clusters from './clusters'

// Alarms notifications
import alarmsNotifications from './alarmsNotifications'

// Gateways stores
import gateway from './gateways/gateway'
import gatewaysSelection from './gateways/selection'
import fileExplorer from './gateways/fileExplorer'

// Multicast group stores
import multicastGroup from './multicastGroup'

// End-devices stores
import endDevice from './endDevices/endDevice'
import endDevicesSelection from './endDevices/selection'

Vue.use(Vuex)

const modules = {
  application,
  home,
  metadata,
  settings,
  capabilities,
  notifications,
  filters,

  roles,
  customers,
  authenticatedUser,
  fleets,
  clusters,

  alarmsNotifications,

  gateway,
  gatewaysSelection,
  fileExplorer,

  multicastGroup,

  endDevice,
  endDevicesSelection
}

if (process.env.NODE_ENV === 'development') {
  // Check there is no duplicates on actions and mutations
  let actions = []
  let mutations = []
  each(modules, (module) => {
    actions = [...actions, ...keys(module.actions)]
    mutations = [...mutations, ...keys(module.mutations)]
  })

  // From https://stackoverflow.com/a/24968449
  const uniqActions = actions.map((act) => { return { count: 1, act: act } }).reduce((a, b) => { a[b.act] = (a[b.act] || 0) + b.count; return a }, {})
  const dupActions = Object.keys(uniqActions).filter((a) => uniqActions[a] > 1)
  const uniqMutations = mutations.map((mut) => { return { count: 1, mut: mut } }).reduce((a, b) => { a[b.mut] = (a[b.mut] || 0) + b.count; return a }, {})
  const dupMutations = Object.keys(uniqMutations).filter((a) => uniqMutations[a] > 1)

  if (dupActions.length > 0) console.warn(`[VueX] Duplicate actions: ${dupActions}`)
  if (dupMutations.length > 0) console.warn(`[VueX] Duplicate mutations: ${dupMutations}`)
}

const vuexLocalStorage = new VuexPersist({
  // Only save these in localStorage
  modules: [ 'gatewaysSelection', 'endDevicesSelection', 'home' ]
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules,
  plugins: [vuexLocalStorage.plugin]
})
